import { careSeekerContractSchema } from "@homeinstead/forms/schemas";
import { z } from "zod";
import { urgencyValues } from "./shared/form-options";

const careSeekerShallowLeadFormSchemaV2 = z.object({
  ...careSeekerContractSchema.shape,
  urgency: z.enum(urgencyValues),
});

export { careSeekerShallowLeadFormSchemaV2 };
